import PropTypes from 'prop-types'
import useAuth from '../hooks/useAuth'
import { hasAnyRole } from '../helpers/permissions'
import NotAuthorised from '../pages/NotAuthorised/NotAuthorised'

/**
 * Renders the page only for a user holding one of `roles`; otherwise the
 * "no access" page. Signing in is AuthChecker's job (it wraps every page),
 * so a signed-out visitor is passed through to it untouched.
 *
 * A usability guard, not access control: it stops a page opening only to
 * fail every request. The API authorises each call itself.
 */
const RequireRoles = ({ roles, children }) => {
    const { user } = useAuth()
    if (!user?.email) return children
    if (hasAnyRole(user.permissions, roles)) return children
    return <NotAuthorised roles={roles} />
}

RequireRoles.propTypes = {
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
    children: PropTypes.node,
}

export default RequireRoles
